/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prefer-stateless-function */
/**
 *
 * Spinner
 *
 */

import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Dimmer, Loader } from "semantic-ui-react";
import messages from "./messages";

interface Props {
  className?: string;
  loading: boolean;
}

class Spinner extends Component<Props> {
  render() {
    return (
      <div>
        {this.props.loading && (
          <Dimmer active inverted id="dimmer">
            <Loader inverted>
              <FormattedMessage {...messages.loading} />
            </Loader>
          </Dimmer>
        )}
        {!this.props.loading && this.props.children}
      </div>
    );
  }
}

export default Spinner;
